
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";

  var onPremRelatedPaths = [
      'formHtmlUrl',
      'buttonData.buttonUrl',
      'formDataUrl',
      'inviteData.inviteUrl',
      'inviteData.inviteDataUrl',
      'versionedResourcesUrl'

  ];

  function getPackageRoot() {
    return window.KAMPYLE_EMBED.getResourcesPrefix();
  }

  function getPackageVersion () {
    return KAMPYLE_UTILS.getNestedPropertyValue(MDIGITAL_CONFIGURATION.getOnsiteConfiguration(),'packageVersion');
  }

  function replaceOnPremPrefixes(rawText) {

    rawText = rawText || '';
    var formattedText;
    if (rawText.indexOf(KAMPYLE_CONSTANT.PLACEHOLDERS.ONPREM_URL_PREFIX) === -1) {
      return rawText;
    }
    else {
      var formattedText = rawText.replace(KAMPYLE_CONSTANT.PLACEHOLDERS.ONPREM_URL_PREFIX, window.KAMPYLE_EMBED.getResourcesPrefix());
      return formattedText;
    }
  }

  function replaceFormNodeUrls(node) {
    if (!node) {
      return false;
    }

    onPremRelatedPaths.forEach(function (path) {
      var pathValue = KAMPYLE_UTILS.getNestedPropertyValue(node, path);
      if (pathValue) {
        KAMPYLE_UTILS.setNestedPropertyValue(node, path, replaceOnPremPrefixes(pathValue))
      }
    });

    return node;
  }

  export default {
    replaceOnPremPrefixes: replaceOnPremPrefixes,
    getPackageVersion: getPackageVersion,
    getPackageRoot: getPackageRoot,
    replaceFormNodeUrls: replaceFormNodeUrls,
  };
